module.exports = __webpack_public_path__ + "static/img/rank_background_official.b1eef5d2.png";